import NotFoundClient from "@/shared/components/features/tenant/not-found-client";

export default function WebsiteNotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-5 text-center">
      <h1 className="text-8xl">404</h1>
      <h2 className="text-2xl sm:text-4xl">Página não encontrada</h2>
      <NotFoundClient />
    </div>
  );
}
